<template>
    <web-layout :racingstars="$page.props.racingstars" :user="$page.props.user">
	    <div class="bg-gray-900 text-white min-h-full h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid lg:px-8 overflow-scroll">
	        <div class="max-w-max mx-auto md:mt-8">
	            <main class="page max-w-5xl">
	                <h1 class="text-5xl mb-4 text-left font-semibold">{{ data.title }}</h1>
	                <div class="w-full text-sm md:text-base" v-html="data.content"></div>
	            </main>
	        </div>
	    </div>
    </web-layout>
</template>

<script>
	import { Link } from '@inertiajs/inertia-vue3';
	import WebLayout from '@/Layouts/WebLayout.vue'

	export default {
		props: {
			data: Object,
		},

		components: {
			Link,
			WebLayout,
		}
	}
</script>
